import { useGetUserType } from 'components/accessControl/hooks/useGetUserType';
import SearchReportRequirementsExceptions, {
  ISearchReportRequirementsExceptionsProps,
} from './SearchReportRequirementsExceptions';
import React from 'react';

export const RequirementsExceptionsPage: React.FC<ISearchReportRequirementsExceptionsProps> = (props) => {
  const userType = useGetUserType();
  return <SearchReportRequirementsExceptions {...props} userType={userType} />;
};
